export function changeLanguage(language) {
  return { type: 'CHANGE_LANGUAGE', language };
}


// WEBPACK FOOTER //
// ./src/js/actions/languageActions.js